var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.66667,-6.66667) scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.879,44c-2.134,0 -3.879,-1.745 -3.879,-3.879v-24.242c0,-2.134 1.745,-3.879 3.879,-3.879h24.242c2.134,0 3.879,1.745 3.879,3.879v24.242c0,2.134 -1.745,3.879 -3.879,3.879z",
    fill: "#ffe082",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,28.559v-17.059c0,-2.2 1.8,-4 4,-4h25c2.2,0 4,1.8 4,4v1.245",
    fill: "none",
    stroke: "#18193f",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,18.617v17.883c0,2.2 -1.8,4 -4,4h-25c-2.2,0 -4,-1.8 -4,-4v-1.755",
    fill: "none",
    stroke: "#18193f",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.271,32.389c0.629,1.026 1.312,2.009 2.758,2.009c1.215,0 1.853,-0.607 1.853,-1.446c0,-1.005 -0.659,-1.362 -1.996,-1.946l-0.733,-0.314c-2.115,-0.901 -3.522,-2.031 -3.522,-4.418c0,-2.199 1.675,-3.873 4.294,-3.873c1.864,0 3.204,0.649 4.17,2.348l-2.283,1.466c-0.503,-0.901 -1.045,-1.256 -1.887,-1.256c-0.859,0 -1.403,0.545 -1.403,1.256c0,0.88 0.545,1.236 1.803,1.78l0.733,0.314c2.492,1.067 3.898,2.156 3.898,4.605c0,2.64 -2.074,4.086 -4.859,4.086c-2.723,0 -4.27,-1.373 -5.131,-3.074z",
    fill: "#18193f",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.623,32.464c0.466,0.827 1.176,1.462 2.195,1.462c0.975,0 1.537,-0.381 1.537,-1.864v-9.662h3.074v10.129c0,3.072 -1.801,4.471 -4.431,4.471c-2.376,0 -4.091,-1.593 -4.79,-3.074z",
    fill: "#18193f",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.3adbe61f9bdcd3798801323f54e3ee73.svg";
export { ForwardRef as ReactComponent };